function getCsrfToken() {
  const meta = typeof document !== "undefined" && document.querySelector("meta[name=csrf-token]");
  return meta ? meta.getAttribute("content") : undefined;
}

async function request(url, { method = "GET", data, headers = {} } = {}) {
  const baseHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const csrfToken = getCsrfToken();
  if (csrfToken) baseHeaders["X-CSRF-Token"] = csrfToken;

  const response = await fetch(url, {
    method,
    credentials: "same-origin",
    headers: { ...baseHeaders, ...headers },
    body: data !== undefined ? JSON.stringify(data) : undefined,
  });

  const contentType = response.headers.get("content-type") || "";
  const parseBody = async () => {
    if (contentType.includes("application/json")) return response.json();
    return response.text();
  };

  const parsed = await parseBody();

  if (!response.ok) {
    const error = new Error("HTTP error " + response.status);
    error.status = response.status;
    error.data = parsed;
    throw error;
  }

  return { data: parsed };
}

const http = {
  get(url, config) {
    return request(url, { method: "GET", ...(config || {}) });
  },
  post(url, data, config) {
    return request(url, { method: "POST", data, ...(config || {}) });
  },
  put(url, data, config) {
    return request(url, { method: "PUT", data, ...(config || {}) });
  },
  delete(url, config) {
    return request(url, { method: "DELETE", ...(config || {}) });
  },
};

export default http;


